export default __webpack_public_path__ + "static/dots-ddd1b6d9be1a443e33e136b34d3bc3c2.png";